import { UserRole } from "types/BETypes";
import { IUserWithCompany } from "types/user";

import { UserProfileResponseDto } from "utils/swagger_react_query";

export const getShouldEmployeeCompleteSignUp = (
  user: Partial<UserProfileResponseDto> | null | undefined,
) => {
  if (user?.activeCompanyUser?.lastActiveRole !== UserRole.EMPLOYEE) return false;
  const res = !user?.personalInfo?.termsAcceptedAt || !user?.isPasswordSet;
  return res;
};

export const getShouldAdminCompleteSignUp = (
  user: Partial<UserProfileResponseDto> | null | undefined,
) => {
  if (
    ![UserRole.ADMIN, UserRole.SUPERADMIN].includes(
      user?.activeCompanyUser?.lastActiveRole as UserRole,
    )
  )
    return false;
  const res = !user?.personalInfo?.termsAcceptedAt || !user?.isPasswordSet;
  return res;
};

export const getShouldOwnerCompleteSignUp = (
  data: IUserWithCompany | undefined,
  companiesIds: string[],
) => {
  const isCompanyExist = !!companiesIds?.length;
  const isUserPasswordSet = !!data?.user?.isPasswordSet;
  const hasUserPersonalInfo = !!data?.user?.personalInfo;
  const res = (!isCompanyExist || !isUserPasswordSet) && !hasUserPersonalInfo;
  return res;
};

export const getIsSetupCompletedWithoutPassword = (
  user: Partial<UserProfileResponseDto> | null | undefined,
) => {
  const isSignUpCompleted =
    user?.activeCompanyUser?.lastActiveRole === UserRole.OWNER
      ? !!user?.activeCompanyUser?.companyId
      : !!user?.personalInfo?.termsAcceptedAt;
  const res = isSignUpCompleted && !user?.isPasswordSet;
  return res;
};

export const getShouldSetPassword = (user: Partial<UserProfileResponseDto> | null | undefined) => {
  return !user?.isPasswordSet;
};
